import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import { useThemeProps, useDateIntervalContext } from "@wsui/base";
import camelCase from "lodash/fp/camelCase";
import upperFirst from "lodash/fp/upperFirst";
import * as index from "./post-cards/index.mjs";
import { useCallback } from "react";
import DefaultPostCard from "./post-cards/DefaultPostCard.mjs";
function defaultComponentMapping(_ref) {
  let {
    postType
  } = _ref;
  let componentName = upperFirst(camelCase(`${postType || "fallback"}PostCard`));
  return index[componentName] || DefaultPostCard;
}
function PostCardController(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "PostCardController"
  });
  let {
    post,
    componentMapping = {},
    visibleFields,
    ...restProps
  } = props;
  const {
    getMostRelevantDate
  } = useDateIntervalContext();
  post = {
    ...post,
    date: post.dates ? getMostRelevantDate(post.dates) : post.date
  };
  const isFieldVisible = useCallback(field => post[field] && (!visibleFields ? true : !!visibleFields[field]), [visibleFields, post]);
  const Component = (typeof componentMapping === "function" ? componentMapping(post, defaultComponentMapping) : post.postType && componentMapping[post.postType]) || defaultComponentMapping(post);
  return /* @__PURE__ */jsx(Component, {
    post,
    visibleFields,
    isFieldVisible,
    ...restProps
  });
}
export { PostCardController as default };